import AccountingProfiles from "@repo/legacy/pages/AccountingProfiles/Index";
import { LoginsPage, SupplierImpersonationPage } from "@repo/shared-user/pages";
import Client from "@repo/legacy/pages/Clients/Edit";
import Clients from "@repo/legacy/pages/Clients/Index";
import Contractor from "@repo/legacy/pages/Contractors/Edit";
import Contractors from "@repo/legacy/pages/Contractors/Index";
import DiscountProfiles from "@repo/legacy/pages/DiscountProfiles/Index";
import EmployeeEdit from "@repo/legacy/pages/Employees/Edit";
import EmployeeList from "@repo/legacy/pages/Employees/Index";
import Freelancer from "@repo/legacy/pages/Freelancers/Edit";
import Freelancers from "@repo/legacy/pages/Freelancers/Index";
import RollingNumbers from "@repo/legacy/pages/RollingNumbers/Index";
import { MailConfiguration } from "@repo/shared-email/pages";
import Services from "@repo/legacy/pages/Services/Index";
import Supplier from "@repo/legacy/pages/Supplier/Edit";
import Suppliers from "@repo/legacy/pages/Supplier/Index";
import { ProtectedRoute } from "@repo/shared/components";
import { ContactAccountPage } from "@repo/shared-contact/pages";
import {
	OfferListPage,
	OfferEditPage,
	InvoiceListPage,
	InvoiceEditPage,
	CreditNoteEditPage,
	MonthlyProjectOverviewPage,
} from "@repo/shared-invoice/pages";
import {
	ProjectEditPage,
	ProjectListPage,
	ProjectManagerTimeSheets,
	MyTimeSheets,
	MyTimeTracking,
} from "@repo/shared-project/pages";
import { MenuKeys } from "@repo/server-api/types";
import { Route, Routes } from "react-router-dom";

import { Dashboard } from "../pages/Dashboard/Index";
import { RuleFactory } from "../rules/RuleFactory";

const AppRoutes = () => {
	return (
		<Routes>
			{/* Dashboard - nicht geschützt (Fallback für nicht autorisierte Benutzer) */}
			<Route path="/" element={<Dashboard />} />

			{/* Employees - geschützt */}
			<Route
				path="/employees/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.EMPLOYEES} ruleFactory={RuleFactory}>
						<EmployeeEdit ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/employees"
				element={
					<ProtectedRoute menuKey={MenuKeys.EMPLOYEES} ruleFactory={RuleFactory}>
						<EmployeeList ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>

			{/* Clients - geschützt */}
			<Route
				path="/clients/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.CLIENTS} ruleFactory={RuleFactory}>
						<Client ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/clients"
				element={
					<ProtectedRoute menuKey={MenuKeys.CLIENTS} ruleFactory={RuleFactory}>
						<Clients />
					</ProtectedRoute>
				}
			/>

			{/* Suppliers - geschützt */}
			<Route
				path="/suppliers/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.SUPPLIERS} ruleFactory={RuleFactory}>
						<Supplier ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/suppliers"
				element={
					<ProtectedRoute menuKey={MenuKeys.SUPPLIERS} ruleFactory={RuleFactory}>
						<Suppliers />
					</ProtectedRoute>
				}
			/>

			{/* Freelancers - geschützt */}
			<Route
				path="/freelancers/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.FREELANCERS} ruleFactory={RuleFactory}>
						<Freelancer ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/freelancers"
				element={
					<ProtectedRoute menuKey={MenuKeys.FREELANCERS} ruleFactory={RuleFactory}>
						<Freelancers />
					</ProtectedRoute>
				}
			/>

			{/* Projects - geschützt */}
			<Route
				path="/projects/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.PROJECTS_LIST} ruleFactory={RuleFactory}>
						<ProjectEditPage ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/projects"
				element={
					<ProtectedRoute menuKey={MenuKeys.PROJECTS_LIST} ruleFactory={RuleFactory}>
						<ProjectListPage />
					</ProtectedRoute>
				}
			/>

			{/* Contractors - geschützt */}
			<Route
				path="/contractors/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.CONTRACTORS} ruleFactory={RuleFactory}>
						<Contractor ruleFactory={RuleFactory} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/contractors"
				element={
					<ProtectedRoute menuKey={MenuKeys.CONTRACTORS} ruleFactory={RuleFactory}>
						<Contractors />
					</ProtectedRoute>
				}
			/>

			{/* Settings - geschützt */}
			<Route
				path="/settings/account"
				element={
					<ProtectedRoute menuKey={MenuKeys.SETTINGS_ACCOUNT} ruleFactory={RuleFactory}>
						<ContactAccountPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings/services"
				element={
					<ProtectedRoute menuKey={MenuKeys.SETTINGS_SERVICES} ruleFactory={RuleFactory}>
						<Services />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings/accounting_profiles"
				element={
					<ProtectedRoute menuKey={MenuKeys.SETTINGS_ACCOUNTING_PROFILES} ruleFactory={RuleFactory}>
						<AccountingProfiles />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings/discount_profiles"
				element={
					<ProtectedRoute menuKey={MenuKeys.SETTINGS_DISCOUNT_PROFILES} ruleFactory={RuleFactory}>
						<DiscountProfiles />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings/rolling_numbers"
				element={
					<ProtectedRoute menuKey={MenuKeys.SETTINGS_ROLLING_NUMBERS} ruleFactory={RuleFactory}>
						<RollingNumbers />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings/mail_configuration"
				element={
					<ProtectedRoute menuKey={MenuKeys.SETTINGS_MAIL_CONFIGURATION} ruleFactory={RuleFactory}>
						<MailConfiguration />
					</ProtectedRoute>
				}
			/>

			{/* Admin - geschützt */}
			<Route
				path="/admin/logins"
				element={
					<ProtectedRoute menuKey={MenuKeys.ADMIN_LOGINS} ruleFactory={RuleFactory}>
						<LoginsPage />
					</ProtectedRoute>
				}
			/>

			{/* Supplier Impersonation - geschützt */}
			<Route
				path="/supplier/impersonation"
				element={
					<ProtectedRoute menuKey={MenuKeys.SUPPLIER_IMPERSONATION} ruleFactory={RuleFactory}>
						<SupplierImpersonationPage />
					</ProtectedRoute>
				}
			/>

			{/* Project Timesheets - geschützt */}
			<Route
				path="/projects/timesheets"
				element={
					<ProtectedRoute menuKey={MenuKeys.PROJECTS_TIMESHEETS} ruleFactory={RuleFactory}>
						<ProjectManagerTimeSheets />
					</ProtectedRoute>
				}
			/>

			{/* My Projects - geschützt */}
			<Route
				path="/my_projects/time_entries"
				element={
					<ProtectedRoute menuKey={MenuKeys.MY_PROJECTS_TIME_ENTRIES} ruleFactory={RuleFactory}>
						<MyTimeTracking />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/my_projects/timesheets"
				element={
					<ProtectedRoute menuKey={MenuKeys.MY_PROJECTS_TIMESHEETS} ruleFactory={RuleFactory}>
						<MyTimeSheets />
					</ProtectedRoute>
				}
			/>

			{/* Monthly Project Overview */}
			<Route
				path="/projects/monthly-overview"
				element={
					<ProtectedRoute menuKey={MenuKeys.PROJECTS_MONTHLY_OVERVIEW} ruleFactory={RuleFactory}>
						<MonthlyProjectOverviewPage />
					</ProtectedRoute>
				}
			/>

			{/* Invoices - geschützt */}
			<Route
				path="/invoices/:status"
				element={
					<ProtectedRoute menuKey={MenuKeys.INVOICES} ruleFactory={RuleFactory}>
						<InvoiceListPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/invoices/:status/:id"
				element={
					<ProtectedRoute menuKey={MenuKeys.INVOICES} ruleFactory={RuleFactory}>
						<InvoiceEditPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path={"/vouchers/:status/:id"}
				element={
					<ProtectedRoute menuKey={MenuKeys.INVOICES} ruleFactory={RuleFactory}>
						<CreditNoteEditPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/offers/:status"
				element={
					<ProtectedRoute menuKey={MenuKeys.OFFERS} ruleFactory={RuleFactory}>
						<OfferListPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path={"/offers/:status/:id"}
				element={
					<ProtectedRoute menuKey={MenuKeys.OFFERS} ruleFactory={RuleFactory}>
						<OfferEditPage />
					</ProtectedRoute>
				}
			/>

			{/* Wildcard - nicht geschützt (leitet zum Dashboard um) */}
			<Route path="*" element={<Dashboard />} />
		</Routes>
	);
};

export default AppRoutes;
